import React, { Fragment } from 'react'
import Component from 'react-component-component'
import { CancelIcon } from 'stylist'
import Location from 'components/Location'
import ServersDropdown from './ServersDropdown'
import Link from '../Link'
import InputContainer from '../InputContainer'
import LabelContainer from '../LabelContainer'

const NavLinkWithDropdown = ({ platform, children, servers }) => (
  <Component
    initialState={{ showInput: false }}
    render={({ state: { showInput, redirectTo }, setState }) => (
      <Fragment>
        <Link
          showInput={showInput}
          onClick={() => setState({ showInput: true })}
        >
          {children}
        </Link>
        {redirectTo ? (
          <Location to={redirectTo} />
        ) : (
          <InputContainer showInput={showInput}>
            <LabelContainer>
              <label>Server</label>
              <CancelIcon
                cursor="pointer"
                onClick={() => setState({ showInput: false })}
                width={20}
                height={20}
              />
            </LabelContainer>
            <ServersDropdown
              servers={servers}
              platform={platform}
              setState={setState}
            />
          </InputContainer>
        )}
      </Fragment>
    )}
  />
)

export default NavLinkWithDropdown



// WEBPACK FOOTER //
// ./src/routes/home/components/MultiServerPlatformNavLink/NavLinkWithDropdown.js